import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { usePathBuilder } from '../../../core/routing/hooks/use-path-builder';
import { PageContainer } from '../../../modules/page-container/page-container';
import { Button } from '../../../visual-components/button/button';
import { FocusFrame } from '../../../visual-components/focus-frame/focus-frame';
import { GridContainer, GridItem } from '../../../visual-components/grid/grid';
import { HighlightBox } from '../../../visual-components/highlight-box/highlight-box';
import { InlineSpacer, Spacer } from '../../../visual-components/spacer/spacer';
import { Typography } from '../../../visual-components/typography/typography';
import { useKeyVisual } from '../hooks/use-key-visual';
import { PopularSeries } from './popular-series';

export const HomeLoggedOut: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const { t } = useTranslation();
  const imageUrl = useKeyVisual();

  const { registerPath } = usePathBuilder();

  return (
    <PageContainer
      documentTitle={t('home.documentTitle')}
      pageHeader={{
        type: 'base',
        content: <FocusFrame text={t('home.pageTitle')} />,
        imgUrl: imageUrl,
      }}
    >
      <GridContainer>
        <GridItem span="12">
          <Typography variant="headline-2">{t('home.documentTitle')}</Typography>
        </GridItem>
      </GridContainer>
      <Spacer size="06" />
      <GridContainer>
        <GridItem span="8">
          <Typography variant="maintext">{t('home.descriptionLogInRegister')}</Typography>
        </GridItem>
      </GridContainer>
      <Spacer size="07" />
      <GridContainer>
        <GridItem span="8">
          <Button
            icon="box-half-arrow-in"
            onClick={() => {
              loginWithRedirect();
            }}
          >
            {t('global.login')}
          </Button>
          <InlineSpacer size="04" />
          <Link to={registerPath()}>
            <Button icon="pen-box" iconPosition="left" variant="secondary">
              {t('global.register')}
            </Button>
          </Link>
        </GridItem>
      </GridContainer>
      <Spacer size="10" />
      <GridContainer>
        <GridItem span="4" spanTablet="6">
          <HighlightBox
            picto="picto-fast-search"
            text={t('home.highlight.fastSearch.text')}
            title={t('home.highlight.fastSearch.title')}
            variant="generic"
          />
        </GridItem>
        <GridItem span="4" spanTablet="6">
          <HighlightBox
            picto="picto-availability"
            text={t('home.highlight.availability.text')}
            title={t('home.highlight.availability.title')}
            variant="generic"
          />
        </GridItem>
        <GridItem span="4" spanTablet="6">
          <HighlightBox
            picto="picto-fast-delivery"
            text={t('home.highlight.fastDelivery.text')}
            title={t('home.highlight.fastDelivery.title')}
            variant="generic"
          />
        </GridItem>
      </GridContainer>
      <PopularSeries />
    </PageContainer>
  );
};
